"use client";
import React, { useEffect, useState } from "react";
import { DELIVERY_MESSAGES } from "@/lib/ads/deliveryDiagnostics";

export default function BrowserAdDiagnostics({ publicationId, advertisingAllowed }) {
  const [open, setOpen] = useState(false);
  const [events, setEvents] = useState([]);
  useEffect(() => {
    const enabled = window.location.hash === "#advertising-diagnostics";
    setOpen(enabled); setEvents([]);
    if (!enabled) return;
    const receive = event => {
      const { placement, code } = event.detail || {};
      if (typeof placement !== "string" || !/^[a-zA-Z0-9_-]{1,100}$/.test(placement) || !Object.hasOwn(DELIVERY_MESSAGES, code)) return;
      setEvents(old => [...old, { placement, code, at: new Date().toISOString() }].slice(-100));
    };
    window.addEventListener("surgedome:ad-diagnostic", receive);
    return () => window.removeEventListener("surgedome:ad-diagnostic", receive);
  }, [publicationId]);
  if (!open) return null;
  const download = () => {
    const url = URL.createObjectURL(new Blob([JSON.stringify({ version: 1, publicationId, events })], { type: "application/json" }));
    const link = document.createElement("a"); link.href = url; link.download = "advertising-browser-report.json"; link.click();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  };
  return <aside aria-label="Advertising browser diagnostics" style={{ position: "fixed", right: 8, bottom: 8, zIndex: 10000, width: "min(380px, calc(100vw - 16px))", maxHeight: "45vh", overflow: "auto", padding: 16, background: "#111", color: "#fff", border: "1px solid #888", font: "14px/1.5 system-ui" }}>
    <strong>Advertising browser check</strong>
    <p>{advertisingAllowed ? "Advertising consent is currently available." : "Advertising consent is unavailable. Use Privacy choices if you wish to grant it."}</p>
    <p>Scroll to the placement. This observes normal delivery; it does not bypass consent, change priorities or force Google requests.</p>
    <p>Events remain in this tab. A Google request or rendered creative does not prove paid demand.</p>
    <ul>{events.slice(-12).map((row, index) => <li key={index}>{row.placement}: <code>{row.code}</code> — {DELIVERY_MESSAGES[row.code]}</li>)}</ul>
    {!events.length && <p>No placement events observed yet.</p>}
    <button onClick={download}>Download report for admin</button>{" "}<button onClick={() => setOpen(false)}>Close</button>
  </aside>;
}
